import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=38a7bcf4&scoped=true&"
import script from "./fieldset.vue?vue&type=script&lang=js&"
export * from "./fieldset.vue?vue&type=script&lang=js&"
import style0 from "./fieldset.vue?vue&type=style&index=0&id=38a7bcf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7bcf4",
  null
  
)

export default component.exports